import { ERROR_CODES } from '../../constants';

const { network_error, OperationNotPermitted, AccessDeniedException } = ERROR_CODES;

export const REFERENCE_ERROR_CODES: any = {
  reference_not_exists: 'reference_not_exists',
  shipment_id_not_found: 'shipment_id_not_found',
  shipment_not_found: 'shipment_not_found',
  shipment_po_rma_not_available_to_scan: 'shipment_po_rma_not_available_to_scan',
  network_error,
  po_not_found: 'po_not_found',
  OperationNotPermitted,
  AccessDeniedException,
  INACTIVE_RECEIVE_REFERENCE: "INACTIVE_RECEIVE_REFERENCE"
};

export const REFERENCE_ERROR_CODES_MAPPING: any = {
  network_error,
  OperationNotPermitted,
  AccessDeniedException,
  reference_not_exists: 'This Scanned ID is not found in Shipment or PO, please scan a valid ID',
  INACTIVE_RECEIVE_REFERENCE: 'Shipment or PO is closed or Inactive, please scan a valid ID.',
  shipment_id_not_found: 'The shipment ID you entered does not exist. ',
  shipment_po_rma_not_available_to_scan: 'Shipment ID,PO or RMA ID is not available to scan, ',
  shipment_not_found: 'The shipment ID you entered does not exist. ',
  po_not_found: 'The PO number or shipment ID you entered does not exist. ',
};

export const DUPLICATE_SHIPMENTS_METRIC = "DuplicateShipmentsScanned";
export const SHIPMENT_NOT_FOUND_METRIC = "ShipmentIdNotFound";

export const RMA_RECIEVE_PAYLOAD = {
  "receiveReference": {
    "externalReferenceValue": "",
    "externalReferenceType": "ASN_RMA",
    "expectedReceiveLocation": "",
    "expectedDeliveryDateTime": "",
    "scannableId": ""
  },
  "scannableIdFoundAs": "RMA_ID",
  "status": {
    "validationStatusType": "OK",
    "statusCode": "",
    "statusMessage": null
  }
}

export const SHIPMENT_MISSING_REASON_CODES = [
  {
    value: 'shipment_missing',
    label: 'Shipment ID is missing',
    description: 'Shipment ID isn’t on physical shipment or packing list.',
  },

  {
    value: 'shipment_damaged',
    label: 'Shipment ID is damaged',
    description: 'Shipment ID isn’t scannable or readable.',
  },
]
